import { createStore } from "vuex";
import auth from "./modules/auth";
import loader from "./modules/loader";
import errors from "./modules/errors";
import attachments from "./modules/attachments";
import notifications from "./modules/notifications";
import counterparties from "./modules/counterparties";
import leads from "./modules/leads";
import projects from "./modules/projects";
import events from "./modules/events";

export default createStore({
  modules: {
    auth,
    loader,
    errors,
    attachments,
    notifications,
    counterparties,
    leads,
    projects,
    events,
  },
});
